var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useEffect, useMemo } from "react";
import { Col, Row, Select } from ".";
import { Fieldset } from "./Fieldset";
import { useTranslation } from "./hooks/useTranslation";
import { Input } from "./Input";
import { useFormContext } from "./Form";
import { Typeahead } from "./Typeahead";
export var updateProvinceList = function (countryList, selectedCountry) {
    var countryProvince = countryList.filter(function (c) { return c.code === selectedCountry; });
    return countryProvince.length === 1
        ? countryProvince[0].provinces.map(function (_a) {
            var name = _a.name, code = _a.code;
            return ({
                label: name,
                value: code,
            });
        })
        : [];
};
export var mapCountries = function (country) {
    return country.map(function (_a) {
        var name = _a.name, code = _a.code;
        return ({
            label: name,
            value: code,
        });
    });
};
export var AddressInput = function (_a) {
    var inputs = _a.inputs, countryList = _a.countryList, country = _a.country, disabled = _a.disabled, legend = _a.legend, _b = _a.fieldset, fieldset = _b === void 0 ? true : _b, id = _a.id;
    var t = useTranslation();
    var memoCountryList = useMemo(function () { return countryList; }, [countryList]);
    if (!fieldset) {
        return (React.createElement(AddressInputComponents, { inputs: inputs, countryList: memoCountryList, country: country, disabled: disabled, id: id }));
    }
    return (React.createElement(Fieldset, { legend: legend || t("Address"), id: id },
        React.createElement(AddressInputComponents, { inputs: inputs, countryList: memoCountryList, country: country, disabled: disabled })));
};
var AddressInputComponents = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var inputs = _a.inputs, countryList = _a.countryList, country = _a.country, disabled = _a.disabled, id = _a.id;
    var t = useTranslation();
    var values = useFormContext().values;
    var _k = useState(inputs.country ? values.get(inputs.country.name) : null), selectedCountry = _k[0], setSelectedCountry = _k[1];
    var _l = useState([]), provinceOptions = _l[0], setProviceOptions = _l[1];
    useEffect(function () {
        if (countryList) {
            setProviceOptions(updateProvinceList(countryList, selectedCountry));
        }
    }, [countryList, selectedCountry]);
    return (React.createElement(Row, { id: id },
        inputs.line1 && (React.createElement(Col, { xs: 12 },
            React.createElement(Input, { name: inputs.line1.name, label: t("Line 1"), disabled: disabled, uniqueId: id && "".concat(id, "__line-1"), required: (_b = inputs.line1.required) !== null && _b !== void 0 ? _b : true }))),
        inputs.line2 && (React.createElement(Col, { xs: 12 },
            React.createElement(Input, { name: inputs.line2.name, label: t("Line 2"), disabled: disabled, uniqueId: id && "".concat(id, "__line-2"), required: (_c = inputs.line2.required) !== null && _c !== void 0 ? _c : false }))),
        inputs.line3 && (React.createElement(Col, { xs: 12 },
            React.createElement(Input, { name: inputs.line3.name, label: t("Line 3"), disabled: disabled, uniqueId: id && "".concat(id, "__line-3"), required: (_d = inputs.line3.required) !== null && _d !== void 0 ? _d : false }))),
        inputs.city && (React.createElement(Col, { xs: 12 },
            React.createElement(Input, { name: inputs.city.name, label: t("City/Town"), disabled: disabled, uniqueId: id && "".concat(id, "__city"), required: (_e = inputs.city.required) !== null && _e !== void 0 ? _e : true }))),
        inputs.state && !countryList && (React.createElement(Col, { xs: 12 },
            React.createElement(Input, { name: inputs.state.name, label: t("Region/State"), disabled: disabled, uniqueId: id && "".concat(id, "__state"), required: (_f = inputs.state.required) !== null && _f !== void 0 ? _f : false }))),
        inputs.postalCode && (React.createElement(Col, { xs: 12 },
            React.createElement(Input, { name: inputs.postalCode.name, label: t("Postal Code"), disabled: disabled, uniqueId: id && "".concat(id, "__postal-code"), required: (_g = inputs.postalCode.required) !== null && _g !== void 0 ? _g : true }))),
        country && (React.createElement(Col, { xs: 12 },
            React.createElement(Typeahead, __assign({ label: t("Country") }, country, { disabled: disabled, uniqueId: id && "".concat(id, "__country") })))),
        countryList && inputs.country && (React.createElement(Col, { xs: 12 },
            React.createElement(Select, { name: inputs.country.name, label: t("Country"), uniqueId: id && "".concat(id, "__country"), options: mapCountries(countryList), onChange: function (newCountry) {
                    setSelectedCountry(newCountry);
                    if (inputs.province) {
                        values.set(inputs.province.name, undefined);
                    }
                }, required: (_h = inputs.country.required) !== null && _h !== void 0 ? _h : true }))),
        countryList && inputs.province && (React.createElement(Col, { xs: 12 },
            React.createElement(Select, { name: inputs.province.name, label: t("Province"), uniqueId: id && "".concat(id, "__province"), options: provinceOptions, required: (_j = inputs.province.required) !== null && _j !== void 0 ? _j : false })))));
};
